/**
 * @file usePrefersReducedMotion.js
 * @description The visitor's prefers-reduced-motion setting, kept current if it changes. Anything that moves on its
 *   own (the home carousel's auto-advance, autoplaying video) checks this first.
 * @module hooks/usePrefersReducedMotion
 */
import { useEffect, useState } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";
const read = () => (typeof window !== "undefined" && window.matchMedia ? window.matchMedia(QUERY).matches : false);

/** @returns {boolean} true when the visitor asked for reduced motion */
export function usePrefersReducedMotion() {
  const [reduced, setReduced] = useState(read);
  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return undefined;
    const mq = window.matchMedia(QUERY);
    const onChange = () => setReduced(mq.matches);
    if (mq.addEventListener) mq.addEventListener("change", onChange);
    else if (mq.addListener) mq.addListener(onChange);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", onChange);
      else if (mq.removeListener) mq.removeListener(onChange);
    };
  }, []);
  return reduced;
}
